export enum CommentRefType {
  Opportunity = "OPPORTUNITY",
  Order = "ORDER",
}

export interface CommentFile {
  name: string;
  url: string;
}

export interface CommentStaff {
  id: number;
  name: string;
  avatar: string;
  isBlocked?: boolean;
}

export interface Comment {
  id: number;
  createdAt: number;
  content: string;
  refType: CommentRefType;
  refId: number;
  files: CommentFile[];
  staff: CommentStaff | null;
  mentionStaffs: CommentStaff[];
  replies: Comment[];
}
